import React from 'react';
import { CategoryFilteredSpellList } from '../shared/CategoryFilteredSpellList';
import Box from '@mui/material/Box';
import { WarbandBuffsPanel } from '../common/WarbandBuffsPanel';

import { createIceSurface } from '../../theme/surfaces';

export const PlayWizardsAndSpellsTab: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, }}>
      <Box sx={createIceSurface(10, { icicles: true, card: true })} p={1.5}>
        <WarbandBuffsPanel />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, ...createIceSurface(300, { icicles: true, card: true }) }} p={1.5}>
        <CategoryFilteredSpellList exclude={true} categoryIds={["out_of_game_a", "out_of_game_b"]} label="In Game Spells" />
      </Box>
    </Box>
  );
};
